/* eslint-disable max-len */
import React from 'react';
import { Image, View, StyleSheet, ScrollView, TouchableOpacity } from 'react-native';
import CustomText from '../../components/customText/CustomText';
import theme from '../../constants/theme.style.js';

const logoFont = require('../../assets/logo-font.png');
const loginTurtle = require('../../assets/Turtles/main-turtle.png');
const waves = require('../../assets/waves.png');

const backButton = require('../../assets/icons/navigation/arrowBack.png');

const styles = StyleSheet.create({
  outerContainer: {
    backgroundColor: theme.GREEN_DARKER_COLOR,
  },
  container: {
    position: 'relative',
    flex: 1,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.GREEN_DARKER_COLOR,
  },
  waveTop: {
    position: 'absolute',
    left: 0,
    top: -30,
    height: 150,
    width: '80%',
    maxWidth: 500,
    zIndex: -20,
  },
  waveBottom: {
    position: 'absolute',
    right: 0,
    bottom: 0,
    height: 150,
    width: '80%',
    maxWidth: 500,
    zIndex: -20,
  },
  logoFont: {
    width: '40%',
    height: 50,
    maxHeight: 80,
    marginBottom: 15,
  },
  innerContainer: {
    padding: theme.CONTAINER_MARGIN,
    paddingTop: 50,
    paddingBottom: 15,
    maxWidth: 600,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 70,
    marginBottom: 70,
    backgroundColor: '#FFF',
    borderRadius: 30,
    zIndex: 999,
  },
  turtleTop: {
    width: '30%',
    height: 70,
    padding: -20,
    marginBottom: 5,
  },
  headline: {
    fontSize: theme.FONT_SIZE_HEADLINE,
    fontWeight: theme.FONT_WEIGHT_HEAVY,
    color: theme.GREY_DARKER_COLOR,
    marginBottom: 5,
  },
  title: {
    fontSize: theme.FONT_SIZE_TITLE,
    fontWeight: theme.FONT_WEIGHT_HEAVY,
    color: theme.GREY_DARKER_COLOR,
    marginTop: 20,
    marginBottom: 5,
  },
  text: {
    fontSize: theme.FONT_SIZE_REGULAR,
    color: theme.BLACK_COLOR,
    marginBottom: 20,
  },
  link: {
    paddingLeft: 5,
    textDecorationLine: 'underline',
    color: theme.GREEN_WARM_COLOR,
    alignSelf: 'center',
  },
  backButtonContainer: {
    width: 60,
    height: 70,
  },
  backButton: {
    width: 40,
    height: 27,
    marginLeft: 20,
    marginTop: 40,
    zIndex: 1000,
  },
});

export default class Data extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  navigateToMainApp = () => {
    const { navigation } = this.props;
    navigation.goBack();
  };

  render() {
    return (
      <ScrollView style={styles.outerContainer}>
        <TouchableOpacity
          onPress={this.navigateToMainApp}
          style={styles.backButtonContainer}
          testID="backButton"
        >
          <Image
            style={styles.backButton}
            source={backButton}
            resizeMode="contain"
            testID="backButtonImg"
          />
        </TouchableOpacity>
        <View style={styles.container}>
          <Image pointerEvents="none" style={styles.waveTop} source={waves} resizeMode="contain" />
          <ScrollView contentContainerStyle={styles.innerContainer}>
            <Image style={styles.logoFont} source={logoFont} resizeMode="contain" />
            <Image style={styles.turtleTop} source={loginTurtle} resizeMode="contain" />
            <CustomText style={styles.title}>Data Policy</CustomText>
            <CustomText style={styles.text}>
              The protection of your personal data is very important to us. We therefore process
              your data exclusively on the basis of the statutory provisions (DSGVO, TKG 2003). In
              this data protection information, we inform you about the most important aspects of
              data processing on our website. When you visit our website, your IP address and the
              beginning and end of the session are recorded for the duration of this session. This
              is due to technical reasons and therefore represents a legitimate interest within the
              meaning of Art 6 Paragraph 1 lit f GDPR. Unless otherwise regulated in the following,
              this data will not be processed by us.
            </CustomText>
            <CustomText style={styles.headline}>Contact with us</CustomText>
            <CustomText style={styles.text}>
              If you contact us by email, the data you provide will be stored by us for six months
              in order to process the request and in the event of follow-up questions. We do not
              pass on this data without your consent.
            </CustomText>
            <CustomText style={styles.headline}>Data storage</CustomText>
            <CustomText style={styles.text}>
              We would like to point out that for the purpose of creating and maintaining a user
              account anyway for successfully sending and receiving messages, we store the following
              data: Nickname, first name, surname, email address, encrypted password, message text,
              date of arrival of the message, recipient as well as the sender of the message, image
              attachments of the message, place where the message was sent. The data you have
              provided are required to use Turtlet. Without this data, neither the app nor the web
              version can be used. There is no data transfer to third parties. The data processing
              takes place on the basis of the legal provisions of § 96 Abs 3 TKG as well as Art 6
              Abs 1 lit a (consent) and / or lit b (necessary to fulfill the contract) of the GDPR.
            </CustomText>
            <CustomText style={styles.headline}>Your rights</CustomText>
            <CustomText style={styles.text}>
              You have the right of information, correction, deletion, restriction, data
              portability, revocation and objection with regard to your data stored by us. If you
              believe that the processing of your data violates data protection law or your data
              protection claims have been violated in any other way, you can complain to us at the
              mail adresses below or to the data protection authority. You can reach us under the
              following contact details:
            </CustomText>
            <CustomText style={styles.text}>atischhart.mmt-m2019@fh-salzburg.ac.at</CustomText>
            <CustomText style={styles.text}>dbuder.mmt-m2019@fh-salzburg.ac.at</CustomText>
            <CustomText style={styles.text}>lseiwald.mmt-m2019@fh-salzburg.ac.at</CustomText>
            <CustomText style={styles.text}>szecha.mmt-m2019@fh-salzburg.ac.at</CustomText>
          </ScrollView>
          <Image
            style={[styles.waveBottom, { transform: [{ rotateY: '180deg' }] }]}
            source={waves}
            resizeMode="contain"
          />
        </View>
      </ScrollView>
    );
  }
}
